import React from 'react'
import { Box, Typography, TextField, Avatar } from '@mui/material'
import { ConfirmWithDialogButton } from 'shared/ui'
import { usePipelineStatus } from './hooks'
import type { PipelineStatusProps } from './types'

export function PipelineStatus({ treeId, versionId }: PipelineStatusProps) {
  const { pipelineStatus, error, handleRemovePipeline } = usePipelineStatus(
    treeId,
    versionId,
  )

  return (
    <Box border={1} borderColor="grey.300" borderRadius={1} p={2} mb={2}>
      <Box display="flex" alignItems="center" gap={1} mb={2}>
        <Avatar
          sx={{
            width: 12,
            height: 12,
            bgcolor: error ? 'warning.main' : 'success.main',
          }}
        />
        <Typography variant="h6" sx={{ fontStyle: 'italic' }}>
          Pipeline
        </Typography>
      </Box>

      {error && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" color="error" gutterBottom>
            Error: {error}
          </Typography>
          <Typography variant="body2" color="error">
            Refresh page to reset.
          </Typography>
        </Box>
      )}

      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <TextField
          value={pipelineStatus}
          placeholder="Pipeline status will appear here..."
          multiline
          rows={2}
          variant="outlined"
          size="small"
          label="Status"
          sx={{ flexGrow: 1 }}
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
      </Box>

      <Box display="flex" alignItems="center" gap={2}>
        <ConfirmWithDialogButton
          variant="outlined"
          color="error"
          dialogTitle="Remove Pipeline"
          dialogContent={
            <Typography>
              Are you sure you want to remove the AI tree tool jobs? All tree
              copy links and processing results will be lost.
            </Typography>
          }
          onClick={handleRemovePipeline}
          cta="Remove"
          cancel="Cancel"
        >
          Remove Pipeline
        </ConfirmWithDialogButton>
      </Box>
    </Box>
  )
}
